export default __webpack_public_path__ + "static/media/story-4.3d837108.png";